<template>
  <section class="blog-kits-item">
    <div class="blog-kits-item__header">
      <a :href="result.detailPage" @click="handlerClick">
        <DefImg v-if="result.picture" :result="result.picture" />
      </a>
    </div>
    <div class="blog-kits-item__footer">
      <DefColorsSmall :result="result" />
      <a :href="result.detailPage" class="blog-kits-item__name" @click="eCommerceSend">{{
        result.type
      }}</a>
      <a
        v-if="result.collection"
        :href="result.collection.detailPage"
        class="blog-kits-item__collection"
      >
        {{ result.collection.name }}
      </a>
      <div v-if="result.price" class="blog-kits-item__prices">
        <DefPrice v-if="result.price.printPrice">{{ result.price.printPrice }}</DefPrice>
        <DefPriceOld v-if="result.price.printPriceOld">{{
          result.price.printPriceOld
        }}</DefPriceOld>
      </div>
    </div>
  </section>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefColorsSmall from '@components/Def/DefColors/DefColorsSmall.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import Analytics from '@/utils/Analytics/Analytics';

export default {
  name: 'BlogKitsItem',
  components: { DefPriceOld, DefPrice, DefColorsSmall, DefImg },
  props: ['result'],
  methods: {
    handlerClick() {
      Analytics.clickOnProduct(this.result);
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-kits-item {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 36px 34px 32px;
    position: relative;
    margin-bottom: 7px;
    @include point-md {
      padding: 24px 22px 26px;
    }
    @include point-lg {
      padding: 26px;
    }
  }
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    margin-bottom: 22px;
    @include point-md {
      margin-bottom: 16px;
    }
    @include point-lg {
      margin-bottom: 19px;
    }
  }
  &__name {
    font-weight: 600;
    font-size: rem(14);
    text-align: center;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 8px;
    max-height: 14px;
    overflow: hidden;
    @include point-md {
      font-size: rem(16);
      max-height: 16px;
    }
  }
  &__collection {
    font-size: rem(11);
    line-height: 110%;
    text-align: center;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-dark-grey);
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 18px;
      font-size: rem(12);
    }
  }
  :deep(.def-price-old) {
    margin-left: 10px;
  }
  :deep(.def-favourite-block) {
    position: absolute;
    top: 12px;
    right: 12px;
  }
  :deep(.def-colors-small) {
    margin-bottom: 12px;
  }
}
</style>
